<div class="container-fluid" dir="rtl">
  <!-- Loading Spinner -->
  <div *ngIf="isLoading" class="text-center my-5">
    <div class="spinner-border text-primary" role="status">
      <span class="visually-hidden">در حال بارگذاری...</span>
    </div>
    <p class="mt-2">در حال بارگذاری اطلاعات فعالیت ماهانه کشاورزی...</p>
  </div>

  <!-- Error Message -->
  <div *ngIf="error && !isLoading" class="alert alert-danger text-center" role="alert">
    <i class="fas fa-exclamation-triangle me-2"></i>
    {{ error }}
    <button type="button" class="btn btn-outline-danger btn-sm ms-3" (click)="goBack()">
      بازگشت
    </button>
  </div>

  <!-- Main Content -->
  <div *ngIf="reportData && !isLoading" class="agriculture-monthly-activity-detail">
    <!-- Header Section -->
    <div class="header-section card mb-4">
      <div class="card-header bg-success text-white">
        <h4 class="mb-0">
          <i class="fas fa-seedling me-2"></i>
          جزئیات فعالیت ماهانه کشاورزی
        </h4>
      </div>
      <div class="card-body">
        <div class="row">
          <div class="col-md-6">
            <p><strong>نماد:</strong> {{ reportData.symbol }} <span *ngIf="reportData.isin">({{ reportData.isin }})</span></p>
            <p><strong>عنوان شرکت:</strong> {{ reportData.title }}</p>
            <p *ngIf="reportData.traceNo"><strong>شماره پیگیری:</strong> {{ reportData.traceNo | persianNumber }}</p>
          </div>
          <div class="col-md-6">
            <p><strong>سال مالی:</strong> {{ reportData.fiscalYear | persianNumber }}</p>
            <p><strong>ماه گزارش:</strong> {{ reportData.reportMonth | persianNumber }}</p>
            <p *ngIf="reportData.yearEndMonth"><strong>پایان سال مالی:</strong> ماه {{ reportData.yearEndMonth | persianNumber }}</p>
            <p *ngIf="reportData.publishDate"><strong>تاریخ انتشار:</strong> {{ reportData.publishDate | jalali }}</p>
          </div>
        </div>
        <div class="row mt-2" *ngIf="reportData.uri">
          <div class="col-12">
            <p><strong>لینک گزارش:</strong>
              <a [href]="reportData.uri" target="_blank" class="btn btn-sm btn-outline-primary ms-2">
                <i class="fas fa-external-link-alt me-1"></i>
                مشاهده در سامانه کدال
              </a>
            </p>
          </div>
        </div>
      </div>
    </div>

    <!-- Items Section -->
    <div class="section-card card mb-4" *ngIf="reportData.items?.length">
      <div class="card-header bg-primary text-white">
        <h5 class="mb-0">
          <i class="fas fa-list me-2"></i>
          اقلام فعالیت ماهانه
        </h5>
      </div>
      <div class="card-body">
        <div class="table-responsive">
          <table class="table table-striped table-hover table-sm" style="font-size: 0.85rem;">
            <thead class="table-dark">
              <tr>
                <th>نام محصول</th>
                <th>واحد</th>
                <th class="text-end">ارزش فروش از ابتدای سال</th>
                <th class="text-end">ارزش فروش اصلاح‌شده</th>
                <th class="text-end">ارزش فروش ماهانه</th>
                <th class="text-end">ارزش فروش انباشته</th>
                <th class="text-end">ارزش فروش سال قبل</th>
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let item of reportData.items"
                [ngClass]="{'table-secondary fw-bold': item.rowCode && item.rowCode !== -1}">
                <td>{{ item.productName }}</td>
                <td>{{ item.unit || '' }}</td>
                <td class="text-end"><span [ngbTooltip]="convertToToman(formatNumber(item.yearToDateSalesAmount))" tooltipClass="tooltip-class">{{ formatNumber(item.yearToDateSalesAmount) }}</span></td>
                <td class="text-end"><span [ngbTooltip]="convertToToman(formatNumber(item.correctedYearToDateSalesAmount))" tooltipClass="tooltip-class">{{ formatNumber(item.correctedYearToDateSalesAmount) }}</span></td>
                <td class="text-end"><span [ngbTooltip]="convertToToman(formatNumber(item.monthlySalesAmount))" tooltipClass="tooltip-class">{{ formatNumber(item.monthlySalesAmount) }}</span></td>
                <td class="text-end"><span [ngbTooltip]="convertToToman(formatNumber(item.cumulativeToPeriodSalesAmount))" tooltipClass="tooltip-class">{{ formatNumber(item.cumulativeToPeriodSalesAmount) }}</span></td>
                <td class="text-end"><span [ngbTooltip]="convertToToman(formatNumber(item.previousYearSalesAmount))" tooltipClass="tooltip-class">{{ formatNumber(item.previousYearSalesAmount) }}</span></td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>

    <!-- Back Button -->
    <div class="mt-3 mb-4">
      <button type="button" class="btn btn-secondary" (click)="goBack()">
        <i class="fas fa-arrow-right me-2"></i>
        بازگشت به لیست
      </button>
    </div>
  </div>
</div>
